import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import ListItemsTable from '../../../../../../features/components/ListItemsTable'
import AdsWrapper from '../AdsWrapper'

import { useSortAds } from '../hooks'

import {
  combinedAdsErrorSelector,
  combinedAdsIsLoadingSelector,
  combinedAdsSelector,
  combinedAdsWasLoadedSelector
} from '../../../../../../modules/selectors/combinedData'
import { selectedAdAccountsSelector } from '../../../../../../modules/selectors/adAccounts'

import { DV_360_PLATFORM, DV_360_PROVIDER_PLATFORM } from '../../../../../../constants/selectLists/platformList'

const DV360HighestPerformingAds = () => {
  const { [DV_360_PLATFORM]: selectedAdAccount = {} } = useSelector(selectedAdAccountsSelector)
  const { currency_symbol: currencySymbol } = selectedAdAccount

  const combinedAds = useSelector(combinedAdsSelector)

  const dv360Ads = useMemo(() => {
    return combinedAds.filter(ad => ad.provider === DV_360_PROVIDER_PLATFORM)
  }, [combinedAds])

  const sortedDV360Ads = useSortAds(dv360Ads)

  return (
    <section id="dv360-ad-cards-list">
      {/*TODO: Replace with AdsGallery when it's ready*/}
      <ListItemsTable
        items={sortedDV360Ads}
        isLoadingSelector={combinedAdsIsLoadingSelector}
        errorSelector={combinedAdsErrorSelector}
        wasLoadedSelector={combinedAdsWasLoadedSelector}
        platform={DV_360_PLATFORM}
        currencySymbol={currencySymbol}
        noDataText={'There are no highest performing Display or Video ads'}
        ContentWrapper={AdsWrapper}
        showGoal={false}
      />
    </section>
  )
}

export default DV360HighestPerformingAds
